<template>
  <div class="TinyMce container-fluid fullHeight margin-Top-3Perc">
    <div class="row">
      <div class="col-lg-12">
        <textarea id="editor">
        </textarea>
      </div>
    </div>
    <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color margin-Top-2Perc" @click="CreateNoteElement">Done</button>
  </div>  
</template>

<script>
import { elementService } from '@/server-util/element-service'
import $ from 'jquery'
require('bootstrap/dist/css/bootstrap.min.css')
export default {
  created: function () {
    this.setDefaultValue()
    this.renderTinyMce()
  },
  data: function () {
    return {
      showAlertDialog: false,
      content: '',
      elementObj: {
        ModuleId: 'e3f51d38-755c-42d1-bc62-ea5bf3f8f45b',
        Title: 'Sample Note 2',
        Duration: '',
        Type: 6,
        VideoUrl: null,
        KalturaEntryId: null,
        KalturaFlavorId: null,
        AudioUrl: 'https://www.kaltura.com/p/1949451/sp/194945100/playManifest/entryId/1_pwoe9p5j/format/url/protocol/http/flavorId/1_yi2dceko/video.mp4',
        AudioEntryId: '1_pwoe9p5j',
        AudioFlavorId: '1_yi2dceko',
        Content: '',
        Index: null,
        RDType: 1,
        IncludeInProgress: false,
        LinkText: null,
        FileUrl: null,
        ElemChallenge: null,
        AllowedResponseTypes: ''
      }
    }
  },
  methods: {
    btnClicked: function () {
      console.log('newValue1: ' + this.content)
    },
    setDefaultValue: function () {
      /* eslint-disable */
      /* eslint-disable */
    },
    renderTinyMce: function () {
      /* eslint-disable */
      $.getScript(
        'https://cloud.tinymce.com/stable/tinymce.min.js?apiKey=qagffr3pkuv17a8on1afax661irst1hbr4e6tbv888sz91jc', () => console.log('loaded script!')
        ).done((script,textStatus ) => {
          console.log( textStatus );
        }).fail(( jqxhr, settings, exception ) => {
          console.log(exception + ': ' + jqxhr.status);
        }
      );
      tinymce.init({
        forced_root_block : "",
        selector: 'textarea#editor',
        height: 400,
        menubar: true,
        plugins: [
          'fullpage advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks advcode fullscreen',
          'insertdatetime media table contextmenu code'
        ],
        setup: (editor) => {
          editor.on('change', () => {
            this.content = editor.getContent()
            this.elementObj.Content = this.content
            // Vue.set(this.elementObj[i], 'Content', this.content);
            console.log('element obj content' + this.elementObj.Content)
          });
        },
        toolbar: 'code fullpage',
        content_css: [
          '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
          '//www.tinymce.com/css/codepen.min.css']
      });
      /* eslint-enable */
    },
    CreateNoteElement: function (event) {
      // alert(JSON.stringify(this.elementObj))
      // console.log('inside create note element')
      var _this = this
      var storeObj = this.$store
      // console.log(JSON.stringify(_this.elementObj))
        elementService
            .createNoteElement(storeObj.state.access_token, _this.elementObj)
            .then(responseObj => {
              console.log('inside element service', _this.elementObj)
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // Refresh Element List by emitting event (LessonListCreateElement option)
                _this.$emit('refreshElementList', true)
              } else {
                // Hide Spinner
                _this.$emit('showSpinner', false)
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // Hide Spinner
              _this.$emit('showSpinner', false)
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        }
  },
  watch: {},
  name: 'TinyMce'
}
</script>

<style scoped>
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.home {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.text-align-center{
  text-align: center;
}
img{
    display: block;
    margin-left: auto;
    margin-right: auto;
    /* width: 40%; */
}
.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.left-color-border
{
	border: 1px solid red;
}
.fourOFourSizecolor{
  font-family: "Proxima Nova";
  font-size:150px;
  color:#777777;
  font-weight: bold;
}
.pageNotFound{
  font-family: "Proxima Nova";
  font-size:72px;
  color:#868686;
  font-weight: bold;  
}
.pageErrorMsg{
  font-family: "Proxima Nova Regular";
  font-size:36px;
  color:#868686;
  font-weight: regular;  

}
.right-color-border
{
	border: 1px solid green;
}
.leftNavBarBG
{
	background-color: #34495e;
  /*border:1px solid #34495e; */
}
.font-size-14px{
	font-size: 30px;
}
.position-Fixed
{
	position:fixed;
}
.float-Right
{
	float: right;
}
.fullHeight
{
	height:100% !important;
}
.fi-border
{
	border: 1px solid white;
}
 .footer-img
 {
    margin: 0 auto !important;
    display: block;
    position: absolute;
    bottom: 0;
	width: 30%;
 }
 .center-block {
   margin-left:auto;
   margin-right:auto;
   display:block;
}
.text-center {
   text-align:center
}
.margin-Top-14Perc
{
	margin-top: 14%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}

.margin-Top-5Perc
{
	margin-top: 5%;
}
.admin-Panel-BG
{
  background-color: #f39c12;
}
.text-align-left
{
  text-align: left;
}
.margin-Left-4Perc
{
  margin-left: 4%;
}
.admin-Panel-Padding
{
  padding:0.1% 0% 0.1% 2%;
}
.font-size-2vw
{
  font-size: 2vw;
}
</style>



// WEBPACK FOOTER //
// src/pages/TinyMce.vue